export default "__VITE_ASSET__8c9bf8b3__"